import { render } from "./InstitutesPageComponent.vue?vue&type=template&id=47609872"
import script from "./InstitutesPageComponent.vue?vue&type=script&lang=js"
export * from "./InstitutesPageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__